import React, { useState, useRef } from 'react';
import { SelectorContainer, SelectorHeader, TabList, TabItem, TabIcon, ActiveArea } from './styles';
import { useAppContext } from 'hooks/useContext';

export default function FreecodeTabSelector({ items, headerComponents }) {
  const { isDarkMode } = useAppContext();

  const [active, setActive] = useState(0);
  const [swipeData, setSwipeData] = useState({});
  const headerRef = useRef(null);

  const handleSwipeEnd = () => {
    try {
      const windowWidth = window.innerWidth;
      const {
        start: { clientX: startX, clientY: startY },
        end: { clientX: endX, clientY: endY },
      } = swipeData;
      const xDiff = Math.abs(startX - endX);
      const yDiff = Math.abs(startY - endY);
      if (windowWidth / xDiff < 3 && xDiff / yDiff > 2) {
        if (startX < endX) {
          setActive(active === 0 ? items.length - 1 : (active - 1) % items.length);
        } else {
          setActive((active + 1) % items.length);
        }
      }
    } catch (e) {
    } finally {
      setSwipeData({});
    }
  };

  return (
    <SelectorContainer isDarkMode={isDarkMode}>
      <SelectorHeader>
        <TabList ref={headerRef}>
          {items.map((item, index) => (
            <TabItem
              id={item.tabId}
              key={index}
              active={index === active}
              isDarkMode={isDarkMode}
              onClick={() => setActive(index)}
            >
              {item.icon && <TabIcon icon={item.icon} />}
              {item.label}
            </TabItem>
          ))}
        </TabList>
        {headerComponents}
      </SelectorHeader>
      <ActiveArea
        isDarkMode={isDarkMode}
        headerHeight={headerRef?.current?.clientHeight ?? 41}
        onTouchStart={(event) => setSwipeData({ start: event?.touches?.[0] })}
        onTouchMove={(event) => setSwipeData({ ...swipeData, end: event?.touches?.[0] })}
        onTouchEnd={handleSwipeEnd}
      >
        {items[active].component}
      </ActiveArea>
    </SelectorContainer>
  );
}
